import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AccountUser } from '../../../../models/account-user.model';

@Component({
    selector: 'lex-manage-user-create',
    templateUrl: './manage-user-create.component.html',
    styleUrls: ['./manage-user-create.component.scss'],
    standalone: false
})
export class ManageUserCreateComponent implements OnInit {

  constructor(private formBuilder: UntypedFormBuilder, private dialogRef: MatDialogRef<ManageUserCreateComponent>) { }

  newUserForm: UntypedFormGroup;
  newUser = {
    userName: '',
    twoFactorEnabled: false,
    message: ''
  } as AccountUser

  ngOnInit(): void {
    this.newUserForm = this.formBuilder.group({
      userEmail: ['', [Validators.required, Validators.email, Validators.maxLength(256)]],
      twoFactorEnabled: new UntypedFormControl(false),
      message: ['', Validators.maxLength(1024)]
    });
  }

  addNewUser(): void {
    this.newUser.userName = this.newUserForm.controls['userEmail'].value;
    this.newUser.twoFactorEnabled = this.newUserForm.controls['twoFactorEnabled'].value;
    this.newUser.message = this.newUserForm.controls['message'].value;
    this.dialogRef.close(this.newUser);
  }

}
